import { FC } from 'react';
import Customers from 'containers/customers/customers';
import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';

const CustomersPage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);
  if (isActionsBlocked) {
    return <MerchantOrTeamBlockedInfo title="Customers" />;
  }
  return <Customers />;
};

export default CustomersPage;
